__turbopack_context__.v({
  "arrow-down": "style-module-scss-module__xv0yiq__arrow-down",
  "arrow-up": "style-module-scss-module__xv0yiq__arrow-up",
  "exp": "style-module-scss-module__xv0yiq__exp",
  "icon": "style-module-scss-module__xv0yiq__icon",
  "label": "style-module-scss-module__xv0yiq__label",
  "listing-detail": "style-module-scss-module__xv0yiq__listing-detail",
  "row": "style-module-scss-module__xv0yiq__row",
});
